import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pointsList: [],
  pointsReaming: 0,
  pointsDetail: [],
  loading: false,
  error: undefined,
};

const pointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchPointsList(state, action) {
      state.pointsList = action.payload;
      state.loading = false;
    },
    fetchReamingPointsList(state, action) {
      state.pointsReaming = action.payload;
      state.loading = false;
    },
  },
});

export const pointsActions = pointsSlice.actions;

export default pointsSlice.reducer;
